import {
	SBBox,
	SBTooltip,
	SBTypography
} from "modules/Commons";
import { useStyles } from "./style";
import SBForecastEvaluationSectionItemValue from "../SBForecastEvaluationSectionItemValue";

export default (props: SBForecastEvaluationSectionItemProps) => {
	const { stat, isOnModal, isAverage = false } = props;
	const { tooltip, ...item } = stat;
	const classes = useStyles();

	return (
		<SBBox className={classes.sectionContainer}>
			<SBBox className={classes.sectionLabel}>
				<SBTooltip title={tooltip} placement="top">
					<SBTypography
						variant="body1"
						className={classes.sectionLabelText}
					>
						{item?.label}
					</SBTypography>
				</SBTooltip>
			</SBBox>
			<SBForecastEvaluationSectionItemValue
				toCompare={stat.toCompare && !props.hideBenchmark}
				model="forecast"
				value={item?.formatter
					? item.formatter(item?.model.forecast.value)
					: item?.model.forecast.value}
				range={item?.model.forecast.range ?? "--"}
				isOnModal={isOnModal}
				isAverage={isAverage}
			/>
			{stat.toCompare && !props.hideBenchmark ?
				<SBForecastEvaluationSectionItemValue
					toCompare={stat.toCompare}
					model="forecastBenchmark"
					value={item?.formatter
						? item.formatter(item?.model.forecastBenchmark?.value)
						: item?.model.forecastBenchmark?.value}
					range={item?.model.forecastBenchmark?.range ?? "--"}
					isOnModal={isOnModal}
				/>
				:
				<></>
			}
		</SBBox>
	);
};

interface SBForecastEvaluationSectionItemProps {
	stat: {
		tooltip: string;
		label: string;
		formatter: (v?: number | undefined) => string;
		model: {
			forecast: {
				value: any;
				range: string;
			},
			forecastBenchmark?: {
				value: any;
				range: string;
			}
		},
		toCompare: boolean;
	},
	isAverage?: boolean;
	isOnModal: boolean;
    hideBenchmark?: boolean;
}
